import { Inject, Singleton } from '@denishussar/html5-game-engine';
import { IAlbumData, IPictureData } from '../Services/CloudDB/Contract';
import { FirebaseCloudDB } from '../Services/CloudDB/FirebaseCloudDB';
import {ISavePictureData, SavesManager} from "../Managers/SavesManager";

@Singleton
export class AlbumsLibrary {

    public static GLORIA = 'gloria';
    public static MY_COLLECTION = 'my_collection';
    public static PICTURE_FTUE = 'FTUE';

    private albums: IAlbumData[] = [];
    private pictures: IPictureData[] = [];
    private categories: string[] = [];

    constructor(
        @Inject private _db: FirebaseCloudDB,
        @Inject private _saveManager: SavesManager,
    ) {
        const data = this._db.getAlbumsLibraryData();
        this.albums = data.albums;
        this.categories = data.categories;
        this.pictures = data.pictures;
    }

    public doesPictureBelongToGloria(pictureId: string): boolean {
        for (let i = 0; i < this.albums.length; i++) {
            const album = this.albums[i];
            if (album.id !== AlbumsLibrary.GLORIA) {
                continue;
            }

            for (let p = 0; p < album.pictures.length; p++) {
                if (pictureId === album.pictures[p]) {
                    return true;
                }
            }
        }
        return false;
    }

    public getAllAlbums(): IAlbumData[] {
        return this.albums;
    }

    public getAlbumData(albumId: string): IAlbumData {
        return this.albums.filter((albumData) => albumData.id === albumId)[0];
    }

    public getPictureData(pictureId: string): IPictureData {
        return this.pictures.filter((pictureData) => pictureData.id === pictureId)[0];
    }

    public getAlbumsInCategory(category: string): IAlbumData[] {
        return this.albums.filter((albumData) => albumData.categories.includes(category));
    }

    public getAlbumByPicture(pictureId: string): IAlbumData {
        for (let i = 0; i < this.albums.length; i++) {
            for (let p = 0; p < this.albums[i].pictures.length; p++) {
                if (this.albums[i].pictures[p] === pictureId) {
                    return this.albums[i];
                }
            }
        }
        return undefined;
    }

    public getRandomPictureBySize(size: number): IPictureData | undefined {
        for (let i = 0; i < this.albums.length; i++) {
            const album = this.albums[i];

            for (let p = 0; p < this.albums[i].pictures.length; p++) {
                const pictureId = album.pictures[p];
                if (pictureId.includes('FTUE')) {
                    continue;
                }

                const picture = this.getPictureData(pictureId);
                if (picture && picture.size === size) {
                    if (!this._saveManager.getSavePicture(pictureId)) {
                        return picture;
                    }
                }
            }
        }
        return undefined;
    }
}
